import {combineReducers} from 'redux';
import without from 'lodash/without';

import {events as eventsDuck} from '@eb/destination-utils';

import {UPDATE_CONTENT} from '../actions/content';
import {UPDATE_EVENT_SAVED_BY_YOU} from '../actions/event';

const {
    actionTypes: {
        UPDATE_COLLECTION_EVENTS,
    },
} = eventsDuck;

const entityContext = (state = [], {type, payload}) => {
    let nextState = state;

    if (type === UPDATE_CONTENT) {
        nextState = payload.entityContext;
    }

    return nextState;
};

const entities = (state = {}, {type, payload}) => {
    let nextState = state;

    if (type === UPDATE_EVENT_SAVED_BY_YOU) {
        const {eventId, savedByYou} = payload;

        nextState = {
            ...nextState,
            [eventId]: {
                ...nextState[eventId],
                saves: {
                    savedByYou,
                },
            },
        };
    } else if (type === UPDATE_CONTENT) {
        nextState = {
            ...nextState,
            ...payload.entities,
        };
    } else if (type === UPDATE_COLLECTION_EVENTS) {
        nextState = {
            ...nextState,
            [payload.eventId]: {
                ...nextState[payload.eventId],
                eventCollections: payload.shouldAdd
                    ? [...nextState[payload.eventId].eventCollections, payload.collectionId]
                    : without(nextState[payload.eventId].eventCollections, payload.collectionId),
            },
        };
    }

    return nextState;
};

const allEventsUrl = (state = '') => {
    const nextState = state;

    return nextState;
};

const categoryArticleMapping = (state = {}) => {
    const nextState = state;

    return nextState;
};

export default combineReducers({
    entityContext,
    entities,
    allEventsUrl,
    categoryArticleMapping,
});
